(()=>{
 const root=document.querySelector('#shopify-section-ks-gear-adaptabell');if(!root)return;
 const modelCards=root.querySelectorAll('.kabc-card');
 root.querySelectorAll('.ks-pdp-option').forEach((button,i)=>{
  const source=modelCards[i]?.querySelector('img');if(!source)return;
  const image=document.createElement('img');image.src=source.src;image.alt='';image.width=128;image.height=128;image.className='ab-model-photo';button.prepend(image);
 });
 const syncSpecs=()=>{
  const selected=root.querySelector('.ks-pdp-option[aria-pressed="true"]');if(!selected)return;
  const max=selected.querySelector('strong')?.textContent.trim()==='MAX';
  const capacity=root.querySelector('#ab-spec-capacity'),build=root.querySelector('#ab-spec-build');
  if(capacity)capacity.textContent=max?'300 LB':'140 LB';
  if(build)build.textContent=max?selected.querySelector('small').textContent.split('·')[0].trim().toUpperCase():'POLYMER';
 };
 root.addEventListener('variant:change',syncSpecs);syncSpecs();
 root.querySelectorAll('a.ks-assurance-item').forEach(link=>{
  const item=document.createElement('div');item.className=link.className;while(link.firstChild)item.append(link.firstChild);link.replaceWith(item);
 });
 const paths=[
  '<path d="M3 7v10m18-10v10M3 12h18m-4-4 4 4-4 4M7 8l-4 4 4 4"/>',
  '<path d="M4 20h16M6 16v-4m6 4V8m6 8V4"/>',
  '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/>'
 ];
 root.querySelectorAll('.ks-pdp-benefits svg').forEach((old,i)=>{if(!paths[i])return;const t=document.createElement('template');t.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+paths[i]+'</svg>';old.replaceWith(t.content.firstElementChild);});
 const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
 if(!motion.matches&&'IntersectionObserver' in window){
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('ab-ed-arrived');observer.unobserve(entry.target);}}),{threshold:.12});
  root.querySelectorAll('.abl-feat,.ab-ed-intro,.kabc-card,.abl-ex-card').forEach(el=>observer.observe(el));
 }
})();
